import type { FieldProps } from 'formik';
import { Field } from 'formik';
import * as React from 'react';

import type { DateInputProps } from '@components/DateInput';
import DateInput from '@components/DateInput/DateInput';

export interface FormikDateFieldProps extends DateInputProps {
  name: string;
}

const FormikDateField: React.FC<FormikDateFieldProps> = ({ ...props }) => {
  const { name, onChange } = props;

  return (
    <Field name={name}>
      {({
        field,
        meta,
        form: { setFieldValue, setFieldTouched },
      }: FieldProps<string>) => (
        <DateInput
          error={meta.touched ? meta.error : ''}
          {...field}
          onChange={(value) => {
            setFieldTouched(field.name, true);
            setFieldValue(field.name, value);
            onChange?.(value);
          }}
          {...props}
        />
      )}
    </Field>
  );
};
export default FormikDateField;
